import { render, staticRenderFns } from "./PaisIndex.vue?vue&type=template&id=75ff9bc6"
import script from "./PaisIndex.vue?vue&type=script&lang=js"
export * from "./PaisIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports